import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

const PaymentStatus = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading"); // States: "loading", "success", "failed"
  const [accessLink, setAccessLink] = useState("");

  useEffect(() => {
    const payment_status = searchParams.get("payment_status");
    const payment_id = searchParams.get("payment_id");
    const payment_request_id = searchParams.get("payment_request_id");

    // 1️⃣ Check if the payment explicitly failed on Instamojo's end
    if (payment_status === "Failed") {
      setStatus("failed");
      return;
    }

    // 2️⃣ If successful, verify with the backend to get the exact link
    if (payment_id && payment_request_id) {
      verifyPayment(payment_id, payment_request_id);
    } else {
      setStatus("failed");
    }
  }, [searchParams]);

  const verifyPayment = async (paymentId, paymentRequestId) => {
    try {
      const response = await axios.post("https://fitnessfreak-44cu.onrender.com/api/payment-success", {
        payment_id: paymentId,
        payment_request_id: paymentRequestId,
      });

      // 🟢 1. Tell Facebook the sale is FINAL and send the EXACT amount
      if (window.fbq) {
        window.fbq('track', 'Purchase', {
          value: response.data.amount, 
          currency: 'INR',
          content_type: 'product',
          content_name: 'Fitness Community Enrollment'
        });
        console.log(`✅ Meta Pixel: Purchase of ₹${response.data.amount} tracked!`);
      }

      setAccessLink(response.data.whatsappLink);
      setStatus("success");
    } catch (error) {
      console.error("Verification Error:", error);
      setStatus("failed");
    }
  };

  // --- UI Renders ---

  if (status === "loading") {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <h2>Processing your payment... ⏳</h2>
      </div>
    );
  }

  // 🔴 Handle Failed Payment
  if (status === "failed") {
    return (
      <div style={{ textAlign: "center", marginTop: "50px", color: "red" }}>
        <h2>❌ Payment Failed</h2>
        <p>Something went wrong with your transaction. Please try again.</p>
        <button onClick={() => window.location.href = "/"}>Go Back</button>
      </div>
    );
  }

  // 🟢 Handle Successful Payment
  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h2 style={{ color: "green" }}>✅ Payment Successful!</h2>
      <p>Click the link below to access your community:</p>
      
      {accessLink && (
        <a 
          href={accessLink} 
          target="_blank" 
          rel="noopener noreferrer"
          style={{
            display: "inline-block",
            marginTop: "20px",
            padding: "12px 24px",
            backgroundColor: "#007bff",
            color: "white",
            textDecoration: "none",
            borderRadius: "5px",
            fontWeight: "bold",
            fontSize: "18px"
          }}
        >
          Click Here to Continue
        </a>
      )}
    </div>
  );
};

export default PaymentStatus;

// import React, { useEffect, useState } from "react";
// import { useSearchParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import KBLogo from "./KBLogo";

// const PaymentStatus = () => {
//   const [searchParams] = useSearchParams();
//   const navigate = useNavigate();

//   const [status, setStatus] = useState("loading"); // loading | success | failed
//   const [accessLink, setAccessLink] = useState("");
//   const [amount, setAmount] = useState("");

// useEffect(() => {
//   const verifyPayment = async (orderId, retries = 10) => {
//     try {
//       const API_BASE =
//         process.env.REACT_APP_BACKEND_URL ||
//         "https://kshitizfits.onrender.com";

//       const response = await axios.post(
//         `${API_BASE}/api/payment/verify`,
//         { orderId }
//       );

//       const data = response.data;

//       if (data.status === "SUCCESS") {
//         setAmount(data.amount);
//         setAccessLink(data.whatsappLink);
//         setStatus("success");
//       } else if (data.status === "PENDING" && retries > 0) {
//         setTimeout(() => verifyPayment(orderId, retries - 1), 2000);
//       } else {
//         setStatus("failed");
//       }

//     } catch (error) {
//       console.error("Verification error:", error);
//       setStatus("failed");
//     }
//   };

//   const orderIdFromUrl = searchParams.get("order_id");

//   if (orderIdFromUrl) {
//     verifyPayment(orderIdFromUrl);
//   } else {
//     setStatus("failed");
//   }

// }, [searchParams]);


//   /* ---------------- LOADING UI ---------------- */
//   if (status === "loading") {
//     return (
//       <div className="min-h-screen bg-charcoal flex flex-col items-center justify-center text-white px-4 text-center">
//         <div className="w-12 h-12 border-4 border-emerald-accent border-t-transparent rounded-full animate-spin mb-6"></div>
//         <h2 className="text-xl font-bold animate-pulse">
//           Verifying your payment...
//         </h2>
//         <p className="text-zinc-500 mt-2 text-sm">
//           Please do not refresh or close this window.
//         </p>
//       </div>
//     );
//   }

//   /* ---------------- FAILED UI ---------------- */
//   if (status === "failed") {
//     return (
//       <div className="min-h-screen bg-charcoal flex flex-col items-center justify-center text-white px-4 text-center">
//         <div className="bg-red-500/10 p-6 rounded-full mb-6">
//           <span className="text-5xl">❌</span>
//         </div>

//         <h2 className="text-3xl font-bold text-red-500 mb-4">
//           Payment Unsuccessful
//         </h2>

//         <p className="text-zinc-400 mb-8 max-w-md mx-auto leading-relaxed">
//           We couldn't confirm your transaction. If money was deducted,
//           please contact support with your order ID.
//         </p>

//         <button
//           onClick={() => navigate("/")}
//           className="px-10 py-4 bg-zinc-800 rounded-2xl font-bold hover:bg-zinc-700 transition-all active:scale-95"
//         >
//           Return Home
//         </button>
//       </div>
//     );
//   }

//   /* ---------------- SUCCESS UI ---------------- */
//   return (
//     <div className="min-h-screen bg-charcoal flex flex-col items-center justify-center text-white px-4 text-center">
//       <KBLogo size={60} />

//       <div className="mt-8 animate-fade-in-up">
//         <div className="bg-emerald-accent/10 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
//           <span className="text-5xl">✅</span>
//         </div>

//         <h2 className="text-3xl font-bold text-emerald-accent mb-2">
//           Welcome to the Community!
//         </h2>

//         <p className="text-zinc-400 mb-10 text-lg">
//           Your payment of ₹{amount} was successful.
//         </p>

//         {accessLink && (
//           <a
//             href={accessLink}
//             target="_blank"
//             rel="noopener noreferrer"
//             className="inline-block px-12 py-5 bg-emerald-accent text-charcoal font-black text-xl rounded-2xl shadow-[0_0_40px_rgba(80,200,120,0.3)] hover:scale-105 active:scale-95 transition-all"
//           >
//             JOIN WHATSAPP GROUP
//           </a>
//         )}

//         <p className="text-zinc-600 mt-8 text-xs italic">
//           A confirmation email has been sent to your registered email.
//         </p>
//       </div>
//     </div>
//   );
// };

// export default PaymentStatus;


